module.exports = __webpack_public_path__ + "static/img/tablet-col.fbaaa4b5.svg";